<template>
  <div class="brand-partner-component">
    <div class="brand-section">
      <h3 class="title font-30">TA们选择了品牌号</h3>
      <div class="body">
        <div class="content-wrapper">
          <img src="@/assets/img/brand/partners.png" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
.brand-partner-component {
  width: 1224px;
  margin: 0 auto;
}
.body {
  padding-top: 40px;
}
.content-wrapper {
  img {
    max-width: 100%;
  }
}
</style>
